import React from 'react';
import PropTypes from 'prop-types';
import { postAPI } from 'store/apiReducer';
import { connect } from 'react-redux';
import {
    GroupeBouton,
    Bouton,
    LoaderMi,
    SelectMi,
    Option,
    Row,
    Col,
    Container,
} from '@design-system-etat/dsfr-react';
import { useForm, FormProvider } from 'react-hook-form';
import usagerClientReducer from 'store/usagerReducer';
import {
    API_CONTACTER_PREFECTURE_PUBLIC,
    CONTEXT_CONTACTER_PREFECTURE,
} from 'constants/apiUrls.constants';
import { DATA_THEME_NON_CONNECTE } from 'constants/contacter.constants';
import formaterContacter from './components/FormaterContacter';
import InformationsUtilisateurNonConnecte from './components/InformationsUtilisateurNonConnecte';
import FormulaireContactGenerique from '../../components/form/formulaireContactGenerique/FormulaireContactGenerique';

const ContacterPrefectureNonConnecte = ({ isLoading, postApi }) => {
    const hookForm = useForm({
        mode: 'onChange',
    });
    const { register, handleSubmit, watch } = hookForm;

    const redirectionPageDeConnexion = () => {
        window.location.href = process.env.REACT_APP_HOST;
    };

    const hasFormValid = () => {
        let formulaireEstvalide = watch('theme') && watch('message');

        formulaireEstvalide =
            formulaireEstvalide &&
            watch('nom') &&
            watch('prenom') &&
            watch('prefecture') &&
            watch('email');

        return formulaireEstvalide;
    };

    const onSubmit = async (dataForm) => {
        if (dataForm && hasFormValid()) {
            const dataFormat = await formaterContacter(dataForm, false);

            postApi(
                usagerClientReducer,
                API_CONTACTER_PREFECTURE_PUBLIC,
                dataFormat,
                CONTEXT_CONTACTER_PREFECTURE,
            );
            setTimeout(() => {
                redirectionPageDeConnexion();
            }, 3000);
        }
    };

    return (
        <Container margeExterne={false}>
            {isLoading && <LoaderMi taille="md" />}
            <Row>
                <Col>
                    <h1>Nous contacter</h1>
                </Col>
            </Row>
            <FormProvider {...hookForm}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <InformationsUtilisateurNonConnecte hookForm={hookForm} />
                    <Row goutierre>
                        <Col col={12} lg={6}>
                            <SelectMi
                                name="theme"
                                label="Thème"
                                placeholder="Sélectionnez un thème"
                                {...register('theme')}
                                required
                            >
                                {DATA_THEME_NON_CONNECTE.map((option) => (
                                    <Option key={option.key} value={option.value}>
                                        {option.libelle}
                                    </Option>
                                ))}
                            </SelectMi>
                        </Col>
                    </Row>
                    <FormulaireContactGenerique />
                    <GroupeBouton alignementHorizontal="right" isHorizontal>
                        <Bouton
                            name="Annuler"
                            label="Annuler"
                            niveau="secondaire"
                            onClick={redirectionPageDeConnexion}
                        />
                        <Bouton
                            name="envoyer"
                            label="Envoyer"
                            niveau="primaire"
                            type="submit"
                            disabled={!hasFormValid() || isLoading}
                        />
                    </GroupeBouton>
                </form>
            </FormProvider>
        </Container>
    );
};

ContacterPrefectureNonConnecte.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    postApi: PropTypes.func.isRequired,
    dataContacterPrefecture: PropTypes.shape({
        mailEnvoye: PropTypes.bool.isRequired,
    }).isRequired,
};

export default connect(
    (state) => {
        const { isLoading } = state.contact.nousContacter;
        return {
            isLoading,
        };
    },
    {
        postApi: postAPI,
    },
)(ContacterPrefectureNonConnecte);
